import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import {  useParams } from 'react-router-dom';
import { useState, useEffect} from 'react';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import LinearProgress from '@mui/material/LinearProgress';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import MenuItem from '@mui/material/MenuItem';
import ViewDocx from './ViewDocx'
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios';
import { HOST } from '../components/config';

const AddFile = (props) => {
  const { caseId } = useParams();
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    display:'block',
    overflow:'scroll',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    height: '80%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  const [S3Urls, setS3Urls] = useState(null)
  
  const [previewUrl, setPreviewUrl] = useState(null); 
  const [previewType, setPreviewType] = useState(null); 

  const [uploadProgress, setUploadProgress] = useState(0);
  const [recognitionRunning, setRecognitionRunning] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const [fileInfo, setFileInfo] = useState({ type: props.defaultType })
  const fileData = props.fileData

  const [errorMessage, setErrorMessage] = useState('')
  
  const [success, setSuccess] = useState(null) 
  const [hidden, setHidden] = useState(false) 

  const handlePreviewFile = async(file_url) => {
      setPreviewUrl(file_url)
      if (fileInfo.filename.includes("pdf"))
        setPreviewType("pdf")
      else if (fileInfo.filename.includes("docx"))
        setPreviewType("docx")
  }
  const fetchNextUploadUrl = () => {
    const uid = uuidv4()
    fetch(HOST + '/api/s3/?uid=' + uid,
    {   
      "method": "POST",
      "headers" : { 
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
        },  
     })
    .then((res) => res.json())
    .then((json) => {
      setS3Urls(json)
      handleFileUpload(json);
   })
  }
  useEffect( () => {
    fetchNextUploadUrl()
    console.log('setup use effect')
    if (!fileInfo.type) {
      setFileInfo((prevState) => ({
        ...prevState,
        ['type']: props.defaultType 
      }));
    }
  }, []);

  const runTypeRecognition = (url) => {
    setRecognitionRunning(true)
    fetch(HOST + '/api/categorize_document/?doc_url=' + encodeURIComponent(url),
    {   
      "method": "POST",
      "headers" : { 
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
        },  
     })
    .then((res) => res.json())
    .then((json) => {
      setRecognitionRunning(false)
      console.log(json.category)
      if (fileInfo['type']  == ''){ 
        setFileInfo((prevState) => ({
          ...prevState,
          ['type']: json.category 
        }))
      }
   })
    .catch(error => {
      setRecognitionRunning(false)
      console.error(error);
    });

  }

  const handleFileUpload = (urls) => {
    const file = fileData;
    const filename = file.name
    setFileInfo((prevState) => ({
      ...prevState,
      'filename': filename
    }))
    axios.put(urls.upload_url, file, {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percentCompleted);
        }
      })
      .then(response => {
        setFileInfo((prevState) => ({
          ...prevState,
          'file_url': urls.download_url 
        }))
        runTypeRecognition(urls.download_url)
      })
      .catch(error => {
        console.error(error);
      });
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    switch (name) {
      default:
        setFileInfo((prevState) => ({
          ...prevState,
          [name]: value
        }));
    }
  };
  
  const handleSubmitUpload = () => {
    setFormSubmitted(true) 
    onUpload(fileInfo, 
      (success) => {
          setSuccess(success); 
          setFormSubmitted(false)
      }, (err)=> {
          setFormSubmitted(false);
          setErrorMessage(err)
      }) 
  }

  const stylePreviewer = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  display:'block',
  overflow:'scroll',
  transform: 'translate(-50%, -50%)',
  width: '70%',
  height: '70%',
  border: '1px solid grey[200]',
  boxShadow: '0 4px 12px rgb(0 0 0 / 0.2)',
  bgcolor: 'background.paper',
    borderRadius: 2,
  p: 4,
};
  const docxPreviewer = <ViewDocx uri={previewUrl} fileType={previewType}/>
  const onCancel = props.onCancel;
  const onUpload = props.onUpload;
  const filename = fileInfo.filename
  const docType = fileInfo.type 
  if (hidden)
    return <></>
      return (      
        <Box sx={{mb: 2}} >
          { previewUrl &&
            <Modal
              open={true}
              onClose={() => setPreviewUrl(null)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
            <Box sx={stylePreviewer}>
              <Typography id="modal-modal-title-preview-docx" variant="h6" component="h2">
                Preview 
              </Typography>
              {docxPreviewer}
            </Box>
            </Modal>
          }
        <form>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {uploadProgress > 0 && uploadProgress < 100 &&
                <>
                  <InputLabel id="add-filename-label">File Upload *</InputLabel>
                  <LinearProgress variant="determinate" value={uploadProgress} />
                </>
              }
            </Grid>
            <Grid item xs={12}>
              <InputLabel id="add-filename-label">Filename *</InputLabel>
              <TextField
                labelId="add-Filename-label"
                name="filename"
                value={filename}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <InputLabel id="type-label">Type *</InputLabel>
            <Select
              name="type"
              value={docType}
              onChange={handleInputChange}
              fullWidth
              required >
                <MenuItem value={''}></MenuItem>
                <MenuItem value={'repair_order'}>Repair Order</MenuItem>
                <MenuItem value={'purchase_contract'}>Purchase Contract</MenuItem>
                <MenuItem value={'lease_agreement'}>Lease Agreement</MenuItem>
                <MenuItem value={'warranty_info'}>Warranty Info</MenuItem>
                <MenuItem value={'other'}>Other</MenuItem>
            </Select>
            </Grid>
            <Grid item xs={12}>
              {errorMessage && 
                <Alert severity="error">{errorMessage}</Alert>
              }
              {recognitionRunning &&
                <Alert severity="info">{"File recognition processing..."}</Alert>
              }
              {formSubmitted && 
                <Alert severity="info">{"File uploading. Please wait."}</Alert>
              }
              {success &&
                <Alert severity="success">{"File successfully added."}</Alert>
              }
            </Grid>
            <Grid item xs={12}>
              {!success &&
                <Button variant="contained" sx={{ mr:1 }} disabled={formSubmitted } color="error" component="span" onClick={() => setHidden(true) }>
                  Remove 
                </Button>
              }
              {uploadProgress == 100 && 
                <Button variant="contained" sx={{ mr:1 }} disabled={formSubmitted } color="info" component="span" onClick={() => handlePreviewFile(fileInfo.file_url)}>
                  Preview 
                </Button>
                
              }
              {!success &&
                <Button variant="contained" disabled={formSubmitted || uploadProgress < 100} color="primary" component="span" onClick={() => handleSubmitUpload()}>
                  Confirm 
                </Button>
              }
            </Grid>
          </Grid>
        </form>
      <Divider sx={{m: 2}} />
      </Box>
      )
}

export default AddFile;
